import { MapAccessBackButton as Button } from 'ui-components'
import { useAuthDefaultWorkspace } from 'user-auth'
import { getWorkspaceLink } from 'utils'

export function MapAccessBackButton() {
  const defaultWorkspace = useAuthDefaultWorkspace()

  return (
    <Button
      href={getWorkspaceLink({
        workspaceId: defaultWorkspace!.id,
        workspaceName: defaultWorkspace!.name
      })}
    />
  )
}
